import { StarIcon } from "@src/assets";
import { RoutePath } from "@src/interfaces";
import { useNavigate } from "react-router-dom";

interface Props {
  amount: string;
}
export const PointsReward = ({ amount }: Props) => {
  const navigate = useNavigate();
  if (Number(amount).toFixed(2) === "0.00") return null;
  return (
    <div className="rounded-[12px] text-text_primary flex w-full items-center justify-between px-4 py-[6px] bg-theme_color/20">
      <div className="flex gap-1 items-center">
        <div className="text-xl font-bold">{`+$${Number(amount).toFixed(
          2,
        )}`}</div>
        <StarIcon className="w-5 h-5" />
        <div className="text-xs">Points</div>
      </div>
      <div
        className="text-xs text-medium text-theme_color whitespace-nowrap cursor-pointer"
        onClick={() => navigate(RoutePath.Rewards)}
      >{`Your rewards >`}</div>
    </div>
  );
};
